// Точка входа SPA: монтирует <App/> в #root. Один раз на загрузку страницы. Реальный композиционный
// корень — App (§4.0); здесь только bootstrap React.

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './app/App.js'

const container = document.getElementById('root')
if (container === null) {
  throw new Error('#root не найден в index.html')
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
